// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 21:34:49

export default {
  "id": "idle-supermarket-tycoon",
  "slug": "idle-supermarket-tycoon",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/02224b554f1440deba32087adfcb7182-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/02224b554f1440deba32087adfcb7182/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Idle Supermarket Tycoon",
      "description": "Build and manage your dream shopping mall! Expand by adding new shops, upgrade interiors, serve customers, and boost your reputation. Invest wisely, assign priority shoppers, and earn extra income with delivery vehicles. Complete missions to unlock rewards!",
      "instructions": "Use the left mouse button to interact with the in-game UI.\nPlus and minus keys = change the size of the camera.",
      "genres": [
        "Casual",
        "Simulation"
      ],
      "tags": [
        "business",
        "idle",
        "manager",
        "real-time-strategy",
        "tycoon"
      ]
    },
    "zh-CN": {
      "title": "闲置超市大亨",
      "description": "建造和管理你的梦想购物中心！通过添加新店铺来扩展，升级内部设施，服务顾客，提升你的声誉。明智投资，指定优先购物者，并用配送车辆赚取额外收入。完成使命以解锁奖励！",
      "instructions": "使用鼠标左键与游戏内UI进行交互。\n加号键和减号键 = 改变镜头大小。",
      "genres": [
        "休闲",
        "模拟"
      ],
      "tags": [
        "商业",
        "模拟经营",
        "管理者",
        "实时策略",
        "大亨"
      ]
    },
    "zh-TW": {
      "title": "閒置超級市場大亨",
      "description": "建造和管理你的夢想購物中心！透過新增商店來擴建，升級內部裝潢，服務顧客，並提升你的聲譽。明智投資，指派優先顧客，並利用送貨車輛賺取額外收入。完成任務以解鎖獎勵！",
      "instructions": "使用滑鼠左鍵與遊戲內UI互動。\n加號和減號鍵 = 改變相機的大小。",
      "genres": [
        "休閒",
        "模擬"
      ],
      "tags": [
        "商業",
        "懶人",
        "經理",
        "即時策略",
        "大亨"
      ]
    },
    "zh-HK": {
      "title": "閒置超級市場大亨",
      "description": "建造和管理你的夢想購物中心！透過新增商店來擴展，升級內部裝潢，服務顧客，提升你的聲譽。明智投資，指定優先顧客，並利用送貨車輛賺取額外收入。完成任務以解鎖獎勵！",
      "instructions": "使用左鍵鼠標與遊戲內UI互動。\n加號和減號鍵 = 改變攝像機的大小。",
      "genres": [
        "休閒",
        "模擬"
      ],
      "tags": [
        "商業",
        "悠閒",
        "經理",
        "即時策略",
        "大亨"
      ]
    },
    "ja": {
      "title": "アイドル・スーパーマーケット・タイクーン",
      "description": "夢のショッピングモールを建設し、管理しよう！新しい店舗を追加して拡張し、内装をアップグレードし、顧客にサービスを提供し、評判を高めよう。賢く投資し、優先顧客を割り当て、配送車で追加収入を得よう。ミッションをクリアして報酬をアンロック！",
      "instructions": "左クリックボタンを使用して、ゲーム内UIとインタラクトします。\nプラスキーとマイナスキー = カメラのサイズを変更します。",
      "genres": [
        "カジュアル",
        "シミュレーション"
      ],
      "tags": [
        "ビジネス",
        "アイドル",
        "マネージャー",
        "リアルタイムストラテジー",
        "タイクーン"
      ]
    },
    "ko": {
      "title": "아이들 슈퍼마켓 타이쿤",
      "description": "드림 쇼핑몰을 건설하고 관리하세요! 새로운 상점을 추가하여 확장하고, 인테리어를 업그레이드하며, 고객을 서비스하고, 명성을 높이세요. 현명하게 투자하고, 우선 고객을 지정하며, 배달 차량으로 추가 수익을 벌어보세요. 미션을 완료하여 보상을 해제하세요!",
      "instructions": "왼쪽 마우스 버튼을 사용하여 인게임 UI와 상호작용합니다.\n플러스 및 마이너스 키 = 카메라 크기 변경",
      "genres": [
        "캐주얼",
        "시뮬레이션"
      ],
      "tags": [
        "비즈니스",
        "아이들",
        "매니저",
        "실시간 전략",
        "타이쿤"
      ]
    },
    "fr": {
      "title": "Tycoon de Supermarché Inactif",
      "description": "Construisez et gérez votre centre commercial de rêve ! Développez-le en ajoutant de nouvelles boutiques, améliorez les intérieurs, servez les clients et boostez votre réputation. Investissez judicieusement, assignez des clients prioritaires et gagnez des revenus supplémentaires avec des véhicules de livraison. Complétez des missions pour débloquer des récompenses !",
      "instructions": "Utilisez le bouton gauche de la souris pour interagir avec l'interface utilisateur du jeu.\nTouches plus et moins = modifier la taille de la caméra.",
      "genres": [
        "Décontracté",
        "Simulation"
      ],
      "tags": [
        "affaires",
        "idle",
        "gestionnaire",
        "stratégie-en-temps-réel",
        "magnat"
      ]
    }
  }
};
